//UI

import { useDispatch } from 'react-redux'

import { hideModal } from '@/stores/ui/modalSlice'
import { Box, Modal, ModalBody, ModalCloseButton, ModalContent, ModalOverlay } from '@chakra-ui/react'

const AnnouncementModal = ({ contentHtml }) => {
  const dispatch = useDispatch()

  const closeModal = () => {
    dispatch(hideModal())
  }
  return (
    <Modal isOpen={true} onClose={closeModal} size="xl">
      <ModalOverlay />
      <ModalContent maxW={'90%'}>
        <ModalCloseButton />
        <ModalBody>
          <Box minH="200px" p={4} dangerouslySetInnerHTML={{ __html: contentHtml }} />
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export default AnnouncementModal
